"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_2hen637nv4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/MoveFilled.tsx";
  var hash = "4b0f2656c628c8d4567bb1e953b6a86958bbd9b6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/MoveFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4b0f2656c628c8d4567bb1e953b6a86958bbd9b6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2hen637nv4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2hen637nv4();
var Icon = (cov_2hen637nv4().s[0]++, {
  name: 'move-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.97609 2.21912C3.54482 1.68004 2.75821 1.59264 2.21913 2.0239C1.68005 2.45516 1.59265 3.24178 2.02391 3.78085L5.75 8.43846V15.0702C5.50706 15.0241 5.25635 15 5 15C2.79086 15 1 16.7908 1 19C1 21.2091 2.79086 23 5 23C5.87616 23 6.68652 22.7183 7.34546 22.2405C7.3961 22.2468 7.44767 22.25 7.5 22.25H22.25V19.75H8.9298C8.97589 19.507 9 19.2563 9 19C9 18.1238 8.7183 17.3135 8.24054 16.6545C8.24678 16.6039 8.25 16.5523 8.25 16.5V7.56151L3.97609 2.21912ZM6.5 19C6.5 19.8284 5.82843 20.5 5 20.5C4.17157 20.5 3.5 19.8284 3.5 19C3.5 18.1716 4.17157 17.5 5 17.5C5.82843 17.5 6.5 18.1716 6.5 19Z\" fill=\"currentColor\"/>\n  <path d=\"M12 7.99998C10.8954 7.99998 10 8.89542 10 9.99998V16C10 17.1046 10.8954 18 12 18H20C21.1046 18 22 17.1046 22 16V9.99998C22 8.89542 21.1046 7.99998 20 7.99998H17V12.5H15V7.99998H12Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;